import type { FaireProductEntity } from "../../entity_types/product";

export const p_3nmm4gy8: FaireProductEntity = {
  token: "p_3nmm4gy8",
  type: "product",
  name: "Sandalwood Rose - 3.5 oz Reed Diffuser",
  brandToken: "b_a9b3b023",
  brandName: "P.F. Candle Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/7132f5b49797b0aaf4d9c9df973d2a1f2331102c70023792084a08ea96b9fa65.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/fb04ea6cf4e90c693ae47b242d0038c8c84efb738882adbec8231bde134d642e.jpeg",
    "https://cdn.faire.com/fastly/64851b8086815f669fb91600ab46fb07f1cb47ed6a69912567dee9b2c35da89f.jpeg",
    "https://cdn.faire.com/fastly/dcf251b4db8351b2edd624e8c187b03f6a2d8696d5f8b2412ac397924d4c2344.jpeg",
    "https://cdn.faire.com/fastly/c49631d3764c8627019b9c648e9fbe03227a92b230c0814d52d2c721eefc2c95.jpeg",
    "https://cdn.faire.com/fastly/3ec3b40ddf2d4f1d916cabf565664c386c5376775b70151546c6ca3cbe6a81fc.jpeg",
    "https://cdn.faire.com/fastly/3b84c7448c1fd4ba405db55ed07ec4e0f06691eb41a63bb53f5e1efcda2c2e1c.jpeg",
  ],
  priceDollars: 14.5,
  description:
    'New York meets Los Angeles. Notes of cashmere rose, oud, and sandalwood. \n\nLow-maintenance, flame-free, and always-on scent for entry ways, bathrooms, dorm rooms, and bedrooms.\n\nEach diffuser contains a 3.5 fl oz blend of naturally-derived and man-made fragrance oils in a 4 oz amber apothecary-inspired bottle. Includes a bundle of 9" long naturally-harvested rattan reeds to absorb and slowly release the fragrance. \n\nLasts approximately 3-4 months, flip reeds weekly.',
  tags: [],
  msrpDollars: 33,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-01T19:03:59.237Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
